import { Controller } from "@hotwired/stimulus"
import { track } from "../analytics/mixpanel"

// Drives the partner dashboard shell chrome: the mobile nav drawer, the
// account menu dropdown (org switching lives there now — see
// _acct_menu.html.erb), and the Partner Dashboard Nav event on nav clicks.
// Pure chrome interactivity — page content is its own React mount.
export default class extends Controller {
  static targets = ["drawer", "acctMenu", "acctMenuMenu"]

  connect() {
    this.closeOnOutside = this.closeOnOutside.bind(this)
    document.addEventListener("click", this.closeOnOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutside)
  }

  toggleDrawer() {
    if (this.hasDrawerTarget) this.drawerTarget.classList.toggle("hidden")
  }

  closeDrawer() {
    if (this.hasDrawerTarget) this.drawerTarget.classList.add("hidden")
  }

  toggleAcctMenu(event) {
    event.stopPropagation()
    if (this.hasAcctMenuMenuTarget) this.acctMenuMenuTarget.classList.toggle("hidden")
  }

  // Collapse the acct menu when clicking anywhere outside it.
  closeOnOutside(event) {
    if (
      this.hasAcctMenuTarget &&
      this.hasAcctMenuMenuTarget &&
      !this.acctMenuTarget.contains(event.target)
    ) {
      this.acctMenuMenuTarget.classList.add("hidden")
    }
  }

  // Fires Partner Dashboard Nav (doc 09). Consent-gated and a no-op without a
  // Mixpanel token, so dev/test stay silent.
  track(event) {
    const toPage = event.currentTarget.dataset.toPage
    if (toPage) track("Partner Dashboard Nav", { to_page: toPage })
  }
}
